import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from '@shared/services/storage.service';
import { AuthService } from '../auth/auth.service';

@Component({
	selector: 'app-unknown',
	templateUrl: './unknown.component.html',
	styleUrls: ['./unknown.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class UnknownComponent implements OnInit {
	theme: string = 'my-light-theme';

	constructor(
		private sessionStorageService: SessionStorageService,
		private router: Router,
		private authService: AuthService,
	) {
		this.sessionStorageService.remove('Selected.ServiceName');
	}

	ngOnInit(): void {
		const isAuth = this.authService.isLoggedIn();
		sessionStorage.setItem('Link.Illegal', 'x');

		if (isAuth) {
			void this.router.navigate(['core']);
		} else {
			void this.router.navigate(['signin']);
		}
	}
}
